import { ArrowRight, BookOpen } from "lucide-react";
import { motion } from "framer-motion";

function Hero() {
  return (
    <section
      id="home"
      className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 via-white to-blue-100 overflow-hidden"
    >
      {/* Background Glow */}

      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[650px] h-[650px] bg-blue-500 opacity-10 blur-[140px] rounded-full"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* Left Side */}

          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >

            <span className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold text-sm mb-5">
              🚀 Learn Future-Ready Digital Skills
            </span>

            <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              Empowering the
              <span className="text-blue-700"> Next Generation </span>
              of Digital Professionals
            </h1>

            <p className="mt-6 text-lg text-gray-600 leading-8">
              Master Web Development, Graphic Design, Digital Marketing,
              Agent AI, and Generative AI through practical,
              project-based learning designed for students,
              professionals, and entrepreneurs.
            </p>

            {/* Features */}

            <div className="grid grid-cols-2 gap-4 mt-8">

              {[
                "Industry Curriculum",
                "Live Projects",
                "Expert Mentorship",
                "Career Guidance",
              ].map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center gap-3"
                >
                  <span className="text-blue-700 text-xl">✔</span>
                  <p>{item}</p>
                </motion.div>
              ))}

            </div>

            {/* Buttons */}

            <div className="flex flex-wrap gap-5 mt-10">

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white px-7 py-4 rounded-full font-semibold transition"
              >
                Explore Courses
                <ArrowRight size={20} />
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-2 border-2 border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white px-7 py-4 rounded-full font-semibold transition"
              >
                <BookOpen size={20} />
                Enroll Now
              </motion.button>

            </div>

          </motion.div>

          {/* Right Side */}

          <motion.div
            className="relative flex justify-center"
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >

            {/* Background Circle */}

            <div className="absolute w-96 h-96 bg-blue-600 rounded-full blur-3xl opacity-20"></div>

            {/* Main Circle */}

            <motion.div
              className="relative bg-blue-700 rounded-full p-8 shadow-2xl"
              animate={{
                y: [0, -12, 0],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >

              <img
                src="/DWP.jpeg"
                alt="Digital with Priyanshi"
                className="w-80 h-80 rounded-full object-cover border-8 border-white"
              />

            </motion.div>

            {/* Floating Cards */}

            <motion.div
              className="absolute top-6 -left-6 bg-white shadow-xl rounded-xl px-5 py-3"
              animate={{ y: [0, -8, 0] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              💻 Web Development
            </motion.div>

            <motion.div
              className="absolute bottom-12 -left-10 bg-white shadow-xl rounded-xl px-5 py-3"
              animate={{ y: [0, -8, 0] }}
              transition={{
                duration: 2.6,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              🎨 Graphic Design
            </motion.div>

            <motion.div
              className="absolute top-20 -right-8 bg-white shadow-xl rounded-xl px-5 py-3"
              animate={{ y: [0, -8, 0] }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              📈 Digital Marketing
            </motion.div>

            <motion.div
              className="absolute bottom-0 right-0 bg-white shadow-xl rounded-xl px-5 py-3"
              animate={{ y: [0, -8, 0] }}
              transition={{
                duration: 3.4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              🤖 AI & Gen AI
            </motion.div>

          </motion.div>

        </div>

      </div>

    </section>
  );
}

export default Hero;